import BaseModel from './Base.model';

/**
 * Model đại diện cho một khách hàng
 */
export default class CustomerModel extends BaseModel {
  /**
   * Tạo một instance mới của Customer
   * @param {Object} data - Dữ liệu khách hàng
   * @param {string} data.id - ID của khách hàng
   * @param {string} data.fullName - Tên khách hàng
   * @param {string} data.phoneNumber - Số điện thoại
   * @param {string} data.email - Email
   * @param {Date} data.dateOfBirth - Ngày sinh
   * @param {number} data.gender - Giới tính
   * @param {string} data.address - Địa chỉ
   * @param {string} data.note - Ghi chú
   * @param {Date} data.createdAt - Ngày tạo
   * @param {Date} data.updatedAt - Ngày cập nhật
   */
  constructor(data = {}) {
    super({
      id: data?.id,
      createdAt: data?.createdAt,
      updatedAt: data?.updatedAt,
    });
    this.fullName = data?.fullName || '';
    this.phoneNumber = data?.phoneNumber || '';
    this.email = data?.email;
    this.dateOfBirth = data?.dateOfBirth;
    this.gender = data?.gender; //1: Nam, 2: Nữ, 3: Khác
    this.address = data?.address || '';
    this.note = data?.note || '';
  }

  /**
   * Trả về tên hiển thị của khách hàng (tên và số điện thoại)
   */
  get displayName() {
    return this.fullName + ' - ' + this.phoneNumber;
  }

  get genderText() {
    const genderName = {
      1: 'Nam',
      2: 'Nữ',
      3: 'Khác',
    };
    return genderName[this.gender] || '';
  }

  validateEmail() {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(this.email);
  }

  validatePhoneNumber() {
    const phoneRegex = /^[0-9]{10,11}$/;
    if (!this.phoneNumber.length === 0) return false;
    return phoneRegex.test(this.phoneNumber);
  }

  /**
   * Chuyển đổi từ dữ liệu JSON thành đối tượng customer
   * @param {Object} json - Dữ liệu JSON
   * @returns {CustomerModel} - Đối tượng customer
   */
  static fromJson(json) {
    return BaseModel.fromJson(json, CustomerModel);
  }

  /**
   * Chuyển đổi từ danh sách JSON thành danh sách đối tượng customer
   * @param {Array} jsonArray - Mảng dữ liệu JSON
   * @returns {Array<CustomerModel>} - Mảng đối tượng customer
   */
  static fromJsonArray(jsonArray) {
    return BaseModel.fromJsonArray(jsonArray, CustomerModel);
  }

  /**
   * Chuyển đổi đối tượng customer thành dữ liệu JSON để gửi lên server
   * @returns {Object} - Dữ liệu JSON
   */
  toJson() {
    return {
      id: this.id,
      storeId: this.storeId,
      productId: this.productId,
      chassisNumber: this.chassisNumber,
      engineNumber: this.engineNumber,
      providerId: this.providerId,
      importPrice: this.importPrice,
      sellPrice: this.sellPrice,
      sellingPrice: this.sellingPrice,
      status: this.status,
      deleted: this.deleted,
    };
  }
}
